export default __webpack_public_path__ + "static/media/217.e580cfbc.gif";